import { z } from "zod"

export enum PhysicianStatus {
	Active = 'Active',
	Inactive = 'Inactive',
	Unknown = 'Unknown',
}

// updating this model?  don't break current data!
// see _UpdatingSchemas.md
// this is a rare bird because I think the database is modding this directly;
// lots of optional items here in that case
export const RPhysician = z.object({
	IsPCP: z.optional(z.boolean()),
	Status: z.optional(z.enum(PhysicianStatus)),
	DateLastEncounter: z.optional(z.string()),
	ClinicianName: z.optional(z.string()),
	Specialty: z.optional(z.string()),
	Phone: z.optional(z.string()),
	Street1: z.optional(z.string()),
	Street2: z.optional(z.string()),
	City: z.optional(z.string()),
	State: z.optional(z.string()),
	Zip: z.optional(z.string()),
})

export type Physician = z.infer<typeof RPhysician>

export const newPhysician = (): Physician => {
	return {
		IsPCP: false,
		Status: PhysicianStatus.Active,
		DateLastEncounter: '',
		ClinicianName: '',
		Specialty: '',
		Phone: '',
		Street1: '',
		Street2: '',
		City: '',
		State: '',
		Zip: '',
	}
}
